(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["par-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Signed off by the owner 2026-09-24. These drive every number a customer
    // sees, so a change here is a business decision — get it re-approved.
    // null = "not typical" for that venue, shown as a dash rather than a quantity.
    var FACTORS = {
      'Bread Plate': { fine: 2.5, casual: 2.5, cafeteria: 6, institutional: 3 },
      'Sandwich Plate': { fine: 2.5, casual: 2.5, cafeteria: 3, institutional: null },
      'Dinner Plate': { fine: 3, casual: 3, cafeteria: 2.5, institutional: 2 },
      'Dessert Plate': { fine: 2, casual: 2.5, cafeteria: 3, institutional: 3 },
      'Lunch Platter': { fine: 1.5, casual: 1.5, cafeteria: 1, institutional: null },
      'Steak Platter': { fine: 1.5, casual: 1.5, cafeteria: 1, institutional: null },
      'Fruit Dish': { fine: 3, casual: 3, cafeteria: 6, institutional: 3 },
      Grapefruit: { fine: 1, casual: 1.5, cafeteria: 1, institutional: 1.5 },
      Bouillon: { fine: 1.5, casual: 1.5, cafeteria: 2, institutional: 1.5 },
      'Rim Soup': { fine: 0.5, casual: 1, cafeteria: 2, institutional: null },
      'Cup/Mug': { fine: 3, casual: 3, cafeteria: 2.5, institutional: 2 },
      Saucer: { fine: 2.5, casual: 3, cafeteria: 2, institutional: 2 },
    };

    var VENUES = [
      { key: 'fine', label: 'Fine Dining', note: 'Multi-course, low turns, full formal service' },
      { key: 'casual', label: 'Casual Dining', note: 'Full-service, moderate turns per meal' },
      { key: 'cafeteria', label: 'Cafeteria', note: 'High volume, self-serve or fast turns' },
      { key: 'institutional', label: 'Institutional', note: 'Healthcare, senior living, corporate dining' },
    ];

    // Pieces round UP to the nearest half dozen — you cannot order 7 plates.
    function dozensFor(pieces) {
      return Math.ceil((pieces / 12) * 2) / 2;
    }

    function init(root) {
      if (root.dataset.parcalcReady) return;
      root.dataset.parcalcReady = '1';

      var endpoint = (root.dataset.endpoint || '').trim();
      var q = function (s) {
        return root.querySelector(s);
      };
      var qa = function (s) {
        return Array.prototype.slice.call(root.querySelectorAll(s));
      };
      var field = function (n) {
        return root.querySelector('[data-field="' + n + '"]');
      };

      var state = { venue: null, seats: null, items: Object.keys(FACTORS).slice(), custom: [] };
      var lastRows = [];
      var firstRender = true;

      // --- build venue cards ---
      var venueBox = q('.parcalc__venues');
      VENUES.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'parcalc__venue';
        b.setAttribute('aria-pressed', 'false');
        b.innerHTML = '<strong></strong><span></span>';
        b.querySelector('strong').textContent = v.label;
        b.querySelector('span').textContent = v.note;
        b.addEventListener('click', function () {
          state.venue = v.key;
          qa('.parcalc__venue').forEach(function (el) {
            el.classList.remove('is-selected');
            el.setAttribute('aria-pressed', 'false');
          });
          b.classList.add('is-selected');
          b.setAttribute('aria-pressed', 'true');
          q('[data-gate="venue"]').disabled = false;
        });
        venueBox.appendChild(b);
      });

      // --- build item checkboxes ---
      var itemBox = q('.parcalc__items');
      Object.keys(FACTORS).forEach(function (name) {
        var row = document.createElement('label');
        row.className = 'parcalc__item';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.checked = true;
        var txt = document.createElement('span');
        txt.textContent = name;
        row.appendChild(cb);
        row.appendChild(txt);
        cb.addEventListener('change', function () {
          if (cb.checked) {
            if (state.items.indexOf(name) === -1) state.items.push(name);
          } else {
            state.items = state.items.filter(function (i) {
              return i !== name;
            });
          }
        });
        itemBox.appendChild(row);
      });

      // --- steps ---
      function showStep(n) {
        qa('.parcalc__step').forEach(function (s) {
          s.hidden = Number(s.dataset.step) !== n;
        });
        qa('.parcalc__track li').forEach(function (d) {
          var i = Number(d.dataset.step);
          d.classList.toggle('is-active', i === n);
          d.classList.toggle('is-done', i < n);
        });
        // Scroll to the top of the PANEL, never the whole widget: the widget
        // starts at the top of the document, so scrolling to it always meant
        // "jump to the very top", which yanked the page on every step.
        // Only move when the panel has actually scrolled off the top, and never
        // on first render. STICKY_H clears the site's fixed header.
        if (!firstRender) {
          var STICKY_H = 90;
          var panel = q('.parcalc__panel');
          var top = panel.getBoundingClientRect().top;
          if (top < STICKY_H) {
            window.scrollTo({
              top: Math.max(0, window.scrollY + top - STICKY_H),
              behavior: 'smooth',
            });
          }
        }
        firstRender = false;
        if (n === 4) mountTurnstile();
      }

      // Render Turnstile the moment its step is actually visible, once.
      var turnstileWidgetId = null;
      function mountTurnstile() {
        var mount = q('[data-turnstile-mount]');
        var key = root.dataset.turnstileKey;
        if (!mount || !key || turnstileWidgetId !== null) return;
        if (!window.turnstile || !window.turnstile.render) {
          // script still in flight — try again shortly
          return void setTimeout(mountTurnstile, 300);
        }
        turnstileWidgetId = window.turnstile.render(mount, {
          sitekey: key,
          theme: 'light',
          'error-callback': function () {
            setStatus('We could not verify your browser. Please reload and try again.', 'err');
          },
        });
      }

      qa('[data-go]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Number(b.dataset.go);
          if (n === 4) render();
          showStep(n);
        });
      });

      var seats = field('seats');
      seats.addEventListener('input', function () {
        var v = parseInt(seats.value, 10);
        state.seats = v > 0 ? v : null;
        q('[data-gate="seats"]').disabled = !state.seats;
      });

      // --- custom items ---
      q('[data-toggle="custom"]').addEventListener('click', function () {
        var box = q('.parcalc__custom');
        box.hidden = !box.hidden;
      });

      function renderChips() {
        var box = q('.parcalc__chips');
        box.textContent = '';
        state.custom.forEach(function (it, idx) {
          var chip = document.createElement('div');
          chip.className = 'parcalc__chip';
          var nm = document.createElement('strong');
          nm.textContent = it.name;
          var f = document.createElement('span');
          f.textContent = 'factor ' + it.factor;
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.textContent = 'Remove';
          rm.addEventListener('click', function () {
            state.custom.splice(idx, 1);
            renderChips();
          });
          chip.appendChild(nm);
          chip.appendChild(f);
          chip.appendChild(rm);
          box.appendChild(chip);
        });
      }

      q('[data-add="custom"]').addEventListener('click', function () {
        var n = field('customName'),
          f = field('customFactor');
        var name = n.value.trim(),
          factor = parseFloat(f.value);
        if (!name || !(factor > 0)) return;
        state.custom.push({ name: name, factor: factor });
        n.value = '';
        f.value = '';
        renderChips();
      });

      // --- results ---
      function render() {
        var venue = VENUES.filter(function (v) {
          return v.key === state.venue;
        })[0];
        q('[data-out="venue"]').textContent = venue ? venue.label : '—';
        q('[data-out="seats"]').textContent = state.seats == null ? '—' : String(state.seats);

        var body = q('[data-out="rows"]');
        body.textContent = '';
        lastRows = [];
        var totalDozens = 0;

        function addRow(name, factor, isCustom) {
          var tr = document.createElement('tr');
          function cell(text, cls) {
            var td = document.createElement('td');
            if (cls) td.className = cls;
            td.textContent = text;
            return td;
          }
          if (factor == null) {
            tr.appendChild(cell(name));
            tr.appendChild(cell('—', 'num'));
            tr.appendChild(cell('—', 'num'));
            tr.appendChild(cell('not typical', 'num is-muted'));
          } else {
            var pieces = Math.round(state.seats * factor);
            var dz = dozensFor(state.seats * factor);
            totalDozens += dz;
            lastRows.push({ item: name, factor: factor, pieces: pieces, dozens: dz });
            tr.appendChild(cell(isCustom ? name + ' (custom)' : name));
            tr.appendChild(cell(String(factor), 'num'));
            tr.appendChild(cell(String(pieces), 'num'));
            tr.appendChild(cell(String(dz), 'num'));
          }
          body.appendChild(tr);
        }

        state.items.forEach(function (name) {
          addRow(name, FACTORS[name][state.venue], false);
        });
        state.custom.forEach(function (it) {
          addRow(it.name, it.factor, true);
        });

        var foot = q('[data-out="total"]');
        foot.textContent = '';
        var tr = document.createElement('tr');
        var label = document.createElement('td');
        label.colSpan = 3;
        label.textContent = 'Total dozens across selected items';
        var val = document.createElement('td');
        val.className = 'num';
        val.textContent = String(Math.round(totalDozens * 2) / 2);
        tr.appendChild(label);
        tr.appendChild(val);
        foot.appendChild(tr);
      }

      // --- reset ---
      q('[data-reset]').addEventListener('click', function () {
        state.venue = null;
        state.seats = null;
        state.custom = [];
        qa('.parcalc__venue').forEach(function (el) {
          el.classList.remove('is-selected');
          el.setAttribute('aria-pressed', 'false');
        });
        qa('.parcalc__items input').forEach(function (cb) {
          cb.checked = true;
        });
        state.items = Object.keys(FACTORS).slice();
        ['seats', 'name', 'title', 'business', 'zip', 'email', 'customName', 'customFactor'].forEach(function (n) {
          var el = field(n);
          if (el) el.value = '';
        });
        q('[data-gate="venue"]').disabled = true;
        q('[data-gate="seats"]').disabled = true;
        q('.parcalc__custom').hidden = true;
        setStatus('', '');
        renderChips();
        showStep(1);
      });

      // --- lead submit ---
      function setStatus(msg, kind) {
        var s = q('.parcalc__status');
        s.textContent = msg;
        s.className = 'parcalc__status' + (kind ? ' is-' + kind : '');
      }

      q('[data-send]').addEventListener('click', function () {
        var btn = this;
        var name = field('name').value.trim();
        var email = field('email').value.trim();

        if (!name) {
          return setStatus('Add your name so we know who to follow up with.', 'err');
        }
        if (!email || email.indexOf('@') < 1) {
          return setStatus('Enter a valid email so we know where to send this.', 'err');
        }
        if (!endpoint) {
          return setStatus("Lead capture isn't connected on this preview yet.", 'err');
        }

        var venue = VENUES.filter(function (v) {
          return v.key === state.venue;
        })[0];
        var payload = {
          name: name,
          title: field('title').value.trim(),
          business: field('business').value.trim(),
          zip: field('zip').value.trim(),
          email: email,
          venue: venue ? venue.label : state.venue,
          venueKey: state.venue,
          seats: state.seats,
          rows: lastRows,
          // Honeypot travels with the payload; the server decides, not the browser.
          hp: field('hp') ? field('hp').value : '',
          // The landing page's utm_* tags, kept for the visit by snippets/jotform-source.liquid
          // (sessionStorage 'tux_utm'), go on the page address when this page has none of its own,
          // so a PAR lead keeps where the visitor came from after browsing to this page.
          pageUrl: (function (href) {
            try {
              var u = new URL(href);
              if (/(^|&)utm_/.test(u.search.slice(1))) return href;
              var saved = JSON.parse(sessionStorage.getItem('tux_utm') || '{}') || {};
              Object.keys(saved).forEach(function (k) {
                if (/^utm_[a-z]+$/.test(k) && saved[k]) u.searchParams.set(k, String(saved[k]).slice(0, 200));
              });
              return u.toString();
            } catch (e) {
              return href;
            }
          })(window.location.href),
        };

        var token = '';
        if (window.turnstile && turnstileWidgetId !== null) {
          try {
            token = window.turnstile.getResponse(turnstileWidgetId) || '';
          } catch (e) {
            token = '';
          }
        }
        if (!token) {
          var ts = root.querySelector('[name="cf-turnstile-response"]');
          token = ts ? ts.value : '';
        }
        // Tell the person, rather than letting the service drop them silently —
        // every response is an identical 200, so the page is the only place a
        // failed check can surface.
        if (!token) {
          btn.disabled = false;
          return setStatus('Still checking your browser — give it a moment and try again.', 'err');
        }
        payload.turnstileToken = token;

        btn.disabled = true;
        setStatus('Sending…', '');

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('http ' + r.status);
            setStatus('Thanks, ' + name.split(' ')[0] + " — we'll follow up at " + email + ' shortly.', 'ok');
          })
          .catch(function () {
            btn.disabled = false;
            setStatus('Something went wrong sending that. Please try again.', 'err');
          });
      });

      // Measure every step and hold the panel at the tallest, so switching steps
      // never changes the document height. Done in one synchronous pass before
      // the first paint, so nothing flickers.
      function lockPanelHeight() {
        var panel = q('.parcalc__panel');
        // Only the three INPUT steps are levelled. The results step is the
        // terminal one and is much taller — including it padded every input step
        // with ~300px of dead space. Growing into step 4 is fine; it is
        // SHRINKING that clamps the scroll and reads as a snap.
        var steps = qa('.parcalc__step:not([data-step="4"])');
        var shown = qa('.parcalc__step').filter(function (s) {
          return !s.hidden;
        });
        panel.style.minHeight = '';
        var tallest = 0;
        steps.forEach(function (s) {
          var was = s.hidden;
          s.hidden = false;
          tallest = Math.max(tallest, s.offsetHeight);
          s.hidden = was;
        });
        qa('.parcalc__step').forEach(function (s) {
          s.hidden = shown.indexOf(s) === -1;
        });
        // offsetHeight is the step alone; the panel adds its own padding.
        var cs = getComputedStyle(panel);
        var pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
        panel.style.minHeight = Math.ceil(tallest + pad) + 'px';
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(lockPanelHeight, 150);
      });

      showStep(1);
      lockPanelHeight();
    }

    function boot() {
      Array.prototype.slice.call(document.querySelectorAll('.parcalc')).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // Theme editor re-renders sections without a page load.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
